// extracted by css-extract-rspack-plugin
export default {"searchInput":"VjFRB7EcR00kQRNt","searchInputDisableBorder":"KA0f7enhN6sPkKh6","searchIcon":"kdcqq0go3UMgxD3b","searchItem":"Rdogeugl8nsBgZTD","search":"_3c4qEn3QeIGMD5V"};